import React from 'react';
import { FilterState } from '../Filters';
import { PipelineOverviewWidget } from '../Widgets/PipelineOverviewWidget';
import { FunnelWidget } from '../Widgets/FunnelWidget';
import { StageHeatmapWidget } from '../Widgets/StageHeatmapWidget';
import { RejectionBreakdownWidget } from '../Widgets/RejectionBreakdownWidget';

interface PropTypes {
  filterState?: FilterState;
}

export function PipelinePerformanceBody(props: PropTypes) {
  return (
    <div className='d-flex flex-column w-100 gap-4'>
      <PipelineOverviewWidget filterState={props.filterState} />
      <FunnelWidget filterState={props.filterState} />
      <StageHeatmapWidget filterState={props.filterState} />
      <RejectionBreakdownWidget filterState={props.filterState} />
    </div>
  );
}
